import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const totalSurveyAttemptAction = createAsyncThunk(
    'total-users-attempt',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/total-survey-attempt?startDate=${data?.startDate}&endDate=${data?.endDate}&publisherId=${data?.publisherId}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const totalSurveyAttemptSlice = createSlice({
    name: 'total-users-attempt',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(totalSurveyAttemptAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(totalSurveyAttemptAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(totalSurveyAttemptAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const totalSurveyAttemptReducer = totalSurveyAttemptSlice.reducer
